// extracted by mini-css-extract-plugin
export default {"root":"UserRequestsTable_root__8Jf5A","row":"UserRequestsTable_row__HB+oZ","boxMargin":"UserRequestsTable_boxMargin__FxIXH","fullHeight":"UserRequestsTable_fullHeight__UBdEr"};